import React from 'react';
import ResourceItemSelector from 'components/ResourceItemSelector';
import { Box, makeStyles } from '@material-ui/core';
import { getImageFile } from 'utils/stringUtils';
import Image from 'components/ResourceItemSmall/components/Image';

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
    height: 171,
    overflow: 'hidden',
  },
  itemContainer: {
    width: 220,
    flexShrink: 0,
  },
  blurredBackground: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    top: 0,
    left: 0,
    filter: 'blur(5px)',
    '-webkit-filter': 'blur(5px)',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundImage: props => `url(${props.backgroundImage})`,
  },
  imageWrapper: {
    position: 'relative',
    zIndex: 1,
    height: '100%',
    width: '100%',
    overflow: 'hidden',
  },
}));

export const SeriesResourcePreview = ({
  isMobile,
  item,
  type,
  trackingPath = 'series',
}) => {
  const classes = useStyles({ backgroundImage });
  const src = getImageFile(item.fields, true);
  const backgroundImage = getImageFile(item.fields);

  return isMobile ? (
    <Box className={classes.root}>
      <div className={classes.blurredBackground} />
      <div className={classes.imageWrapper}>
        <Image file={src} type={type} />
      </div>
    </Box>
  ) : (
    <div className={classes.itemContainer}>
      <ResourceItemSelector
        item={item}
        trackingPath={trackingPath}
        asLink={false}
      />
    </div>
  );
};
